import { ContentContainer } from "@jane/lib/src/components/content/ContentContainer"
import { PageHeader } from "@jane/lib/src/components/content/PageHeader"
import React, {ReactNode} from "react"
import {usePermissions} from "../../resources/PermissionsHook";
import {AppPreferences} from "./appSettings/AppPreferences";
import {CachePreferences} from "./appSettings/AppCache";
import {LogsLink} from "./appSettings/LogsSettings";
import {TelephonePreferences} from "./appSettings/TelephoneSettings";
import {SocialCardPreferences} from "./appSettings/SocialCardPreferences";
import {useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";

export default function SettingsPage(): ReactNode {
  const { canAccessLogs, canAccessPhone, canManageSocialCards, canManageAppPreferences, canManageCache } = usePermissions()

  const { settings: settingsApi } = useApiCall(config)
  const { resource: settings, isLoading, reload } = useApiEndpoint(() => settingsApi.all(), canManageAppPreferences)

  return <ContentContainer>
    <PageHeader>Instellingen</PageHeader>
    {canAccessLogs && <LogsLink />}
    {canAccessPhone && <TelephonePreferences settings={settings} onUpdated={reload} />}
    {canManageSocialCards && <SocialCardPreferences />}
    {canManageAppPreferences && settings && <AppPreferences settings={settings} onUpdated={reload} />}
    {canManageCache && <CachePreferences settings={settings} onUpdated={reload} />}
  </ContentContainer>
}

export function SettingsContainer(props: {title: string, description: string, children: ReactNode}): ReactNode {
  return <div className={"mt-5"}>
    <h2>{props.title}</h2>
    <div className="mt-3 md:space-x-6 flex flex-col md:flex-row items-start">
      <div className={"w-full md:flex-1"}>
        <p className={"pl-3 max-w-md py-1 tracking-wide text-slate-600 border-l-2 border-blue-400 text-sm"}>{props.description}</p>
      </div>
      <div className={"md:w-1/2 rounded-xs"}>{props.children}</div>
    </div>
  </div>
}